import React from "react";
import NoResultIcon from "../../../image/icons/itinerary/NoResult.svg";

interface NoResultsProps {
    "departureLat": number;
    "departureLon": number;
    "arrivalLat":   number;
    "arrivalLon":   number;
}

const NoResults: React.FC<NoResultsProps> = ( {
    departureLat,
    departureLon,
    arrivalLat,
    arrivalLon,
} ) => {
    const sameLocation = arrivalLat === departureLat && arrivalLon === departureLon;

    return (
        <div className="w-full my-4">
            <div className="flex justify-center">
                <img
                    className="mb-5"
                    src={NoResultIcon}
                />
            </div>
            <p className="text-center text-ionic-gray">
                {`Aucun itinéraire trouvé. ${ sameLocation ? "Veuillez sélectionner des adresses différentes" : "Réessayez plus tard ou prenez votre propre voiture." }`}
            </p>
            {!sameLocation &&
              <div className="flex justify-center py-5">
                  <span className="p-2 px-5 rounded-lg text-center bg-[#76919B] text-white">
                      Me Notifier
                  </span>
              </div>}
        </div>
    );
};

export default NoResults;
